import { EService } from '../enums/EService';

export const getServiceColor = (service: EService) => {
  if (service === EService.FIRST_SERVICE) {
    return 'primary';
  }
  if (service === EService.MAJOR_SERVICE) {
    return 'secondary';
  }
  return 'warning';
};
